import { z } from "zod";

// Rejects `javascript:`, `data:`, etc. — checkoutUrl flows into an <a href>
// and imageUrl into a CSS url(...). Both are XSS surfaces.
const httpUrl = z.string().regex(/^https?:\/\//i);

export const LessonCardSchema = z.object({
  coachName: z.string().min(1),
  sport: z.string().min(1),
  imageUrl: httpUrl.nullable().optional(),
  locationName: z.string().min(1),
  whenLabel: z.string().min(1),
  durationMinutes: z.number(),
  participants: z.number(),
  // 1, 3 or 10 — the only pack sizes TeachMe.To's checkout accepts. Anything
  // else is parsed to null on their side, so the total we'd show would be a
  // number they never charge.
  lessons: z.union([z.literal(1), z.literal(3), z.literal(10)]).default(1),
  // Per-lesson rate for the chosen pack size — null when TeachMe.To didn't
  // publish one, in which case the card says "At checkout" rather than guess.
  lessonPrice: z.number().nullable().optional(),
  // Court fee the STUDENT pays, on top. Coach-paid fees never reach here.
  courtFee: z.number().nullable().optional(),
  checkoutUrl: httpUrl,
});

export type LessonCardData = z.infer<typeof LessonCardSchema>;

export function validateLessonCard(value: unknown): LessonCardData | null {
  const parsed = LessonCardSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
